"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var timer_1 = __importDefault(require("./tools/timer"));
var Delay = /** @class */ (function () {
    function Delay(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, 
        // @ts-ignore
        delayInSeconds = _b.delayInSeconds, 
        // @ts-ignore
        onDelayExpired = _b.onDelayExpired;
        this.isDelaying = true;
        this.onDelayExpired = onDelayExpired;
        if (delayInSeconds > -1) {
            this.timer = new timer_1.default({
                callback: function () {
                    _this.finish();
                },
                delay: delayInSeconds,
                autoStart: true
            });
        }
        else {
            this.finish();
        }
    }
    Delay.prototype.finish = function () {
        this.isDelaying = false;
        if (this.onDelayExpired) {
            this.onDelayExpired();
        }
    };
    Delay.hydrate = function (obj) {
        var delay = Object.assign(new Delay(), obj);
        delay.timer = timer_1.default.hydrate(obj.timer);
        return delay;
    };
    return Delay;
}());
exports.default = Delay;
